<ng-template let-extraClass="extraClass" #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'How would you like to add a workflow?'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    <tidy-card class="concierge-alert default-card">
      <tidy-card-button
        class="arrow-to-top"
        style="padding-bottom: 0px"
        (action)="goToAddConciergeTask()">
        <tidy-row class="vertical-align-center">
          <tidy-image [src]="'assets/img/concierge.svg'" class="header-size" />
          <tidy-text [header]="'Have Concierge Set Up For Me'" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="'TIDY can help solve almost any workflow revolving around cleaning and maintenance. We recommend having our team of experts set them up for you, free!'" />
        </tidy-row>
      </tidy-card-button>
    </tidy-card>

    <tidy-card class="default-card">
      <tidy-card-button
        class="arrow-to-top"
        style="padding-bottom: 0px"
        (action)="goToBuildFromSketch()">
        <tidy-row class="vertical-align-center">
          <tidy-image [src]="'assets/icon/sketch.png'" class="header-size" />
          <tidy-text [header]="'Build from Scratch'" />
        </tidy-row>
        <tidy-row>
          <tidy-text [body]="'Pick a trigger and set of actions.'" />
        </tidy-row>
      </tidy-card-button>
    </tidy-card>

    <tidy-card class="workflows-alert-row default-card">
      <tidy-row class="vertical-align-center">
        <tidy-image [src]="'assets/icon/popular.png'" class="header-size" />
        <tidy-text [header]="'Start from a Popular Workflow'" />
      </tidy-row>
      <tidy-row>
        <tidy-text [body]="'See what others do.'" />
      </tidy-row>

      <tidy-row class="field-top-padding">
        <tidy-search-input
          class="full-width"
          [placeholder]="'Search workflows...'"
          [fixedWidth]="false"
          (valueChange)="filterWorkflows($event)" />
      </tidy-row>

      @for (item of recommendedWorkflows; track item; let i = $index) {
        <tidy-card>
          <tidy-card-button (action)="goToEditByRecommendedWorkflow(i)">
            <tidy-row class="vertical-align-center">
              <div class="workflow-icon" [style.background-color]="getCategoryBackgroundColor(item.trigger.category)">
                <tidy-image [src]="getCategoryIcon(item.trigger.category)" />
              </div>
              <tidy-text [body]="item.description" />
            </tidy-row>
          </tidy-card-button>
        </tidy-card>
      }
    </tidy-card>
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
